import React from 'react';

const LocationTab = ({ location }) => {
  return (
    <div className="card w-100 h-100">
      <div className="card-body p-8">
        <div className="location-content mb-4">
          <p>{location}</p>
        </div>
        <div className="google-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.7168542751736!2d77.57823599999999!3d30.296953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390929e9bd20fbb3%3A0xaa8296cf4a257c29!2sAbhyaranyan!5e0!3m2!1sen!2sin!4v1653647282959!5m2!1sen!2sin"
            style={{ border: 0, width: '100%', height: '400px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Location Map"
          />
        </div>
      </div>
    </div>
  );
};

export default LocationTab;
